import React from "react";
import PropTypes from "prop-types";

import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

import { fonts } from "../../../styles/variables";

const activeStyles = css`
  border-bottom: black solid 2px;
  font-family: ${fonts.fontInterstateUltraBlack};
  letter-spacing: -0.025em;
  -webkit-letter-spacing: -0.025em;
  text-transform: uppercase;
`;

const StyledTab = styled(NavLink).attrs(() => ({ exact: true }))`
  flex: 1;
  border-bottom: transparent solid 2px;
  font-family: ${fonts.fontConceptRegular};
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0 20px;
  flex-wrap: nowrap;
  white-space: nowrap;
  text-transform: capitalize;

  &.active {
    ${activeStyles};
  }

  &::after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background: black;
    transform: scaleX(0);
    transition: transform 250ms ease-in-out;
  }

  /* slide from right */
  &:first-child::after {
    transform-origin: 100% 50%;
  }

  /* slide from left */
  & + a:last-child::after {
    transform-origin: 0 50%;
  }
`;

const ActiveTab = styled(StyledTab)`
  ${activeStyles};
`;

const GuidesTab = ({ children, to, isActive = false }) =>
  isActive ? (
    <ActiveTab to={to}>
      <span>{children}</span>
    </ActiveTab>
  ) : (
    <StyledTab to={to}>
      <span>{children}</span>
    </StyledTab>
  );

GuidesTab.propTypes = {
  to: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]).isRequired,
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
};

export default GuidesTab;
